/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DataPointMapLocation
 */
export interface DataPointMapLocation {
    /**
     * 
     * @type {DataPointMapLocationTypeEnum}
     * @memberof DataPointMapLocation
     */
    type: DataPointMapLocationTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof DataPointMapLocation
     */
    coordinates: Array<number>;
}


/**
 * @export
 */
export const DataPointMapLocationTypeEnum = {
    Point: 'Point'
} as const;
export type DataPointMapLocationTypeEnum = typeof DataPointMapLocationTypeEnum[keyof typeof DataPointMapLocationTypeEnum];


/**
 * Check if a given object implements the DataPointMapLocation interface.
 */
export function instanceOfDataPointMapLocation(value: object): value is DataPointMapLocation {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'Point') return false;
    
    if (!('coordinates' in value) || value['coordinates'] === undefined) return false;
    return true;
}

export function DataPointMapLocationFromJSON(json: any): DataPointMapLocation {
    return DataPointMapLocationFromJSONTyped(json, false);
}

export function DataPointMapLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DataPointMapLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'coordinates': json['coordinates'],
    };
}

export function DataPointMapLocationToJSON(json: any): DataPointMapLocation {
    return DataPointMapLocationToJSONTyped(json, false);
}

export function DataPointMapLocationToJSONTyped(value?: DataPointMapLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'coordinates': value['coordinates'],
    };
}

